import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './translation/locales/en/translation.json';
import frTranslation from './translation/locales/fr/translation.json';
import esTranslation from './translation/locales/es/translation.json';
import deTranslation from './translation/locales/de/translation.json';

const resources = {
    en: { translation: enTranslation },
    fr: { translation: frTranslation },
    es: { translation: esTranslation },
    de: { translation: deTranslation },
};

i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem('i18n-key') ?? 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
